import { Link } from 'react-router-dom';
import { Zap, MapPin, Phone, Mail, Facebook, Instagram, Linkedin, Twitter } from 'lucide-react';
import { company } from '../mock';
import { FooterLatestArticles } from './FooterLatestArticles';

export default function Footer() {
  return (
    <footer className="bg-[#0b0b0d] text-white border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3">
              {company.logo ? (
                <img
                  src={company.logo}
                  alt="Prakash Electrodes"
                  className="h-12 w-auto object-contain drop-shadow-lg"
                />
              ) : (
                <div className="h-11 w-11 rounded-md bg-amber-500 flex items-center justify-center">
                  <Zap className="h-6 w-6 text-[#0b0b0d]" strokeWidth={2.5} />
                </div>
              )}
              <div>
                <div className="font-display text-lg font-semibold">Prakash Electrodes</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.18em] text-amber-500/80">
                  Private Limited • Since 1985
                </div>
              </div>
            </Link>
            <p className="mt-5 text-white/60 text-sm max-w-md leading-relaxed">
              Manufacturing premium welding electrodes for India&rsquo;s industrial and construction
              sectors from Kota, Rajasthan.
            </p>
            <div className="mt-6 flex gap-2">
              {[Facebook, Instagram, Linkedin, Twitter].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="h-9 w-9 rounded-md border border-white/10 flex items-center justify-center hover:bg-amber-500 hover:border-amber-500 hover:text-[#0b0b0d] transition-colors"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-[0.14em] text-white/50 font-medium mb-4">
              Explore
            </h4>
            <ul className="space-y-3">
              {['Home', 'Products', 'Insights', 'About', 'Contact'].map((l) => (
                <li key={l}>
                  <Link
                    to={l === 'Home' ? '/' : `/${l.toLowerCase()}`}
                    className="text-white/70 hover:text-amber-400 transition-colors text-sm"
                  >
                    {l}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/welding-electrodes-in"
                  className="text-white/70 hover:text-amber-400 transition-colors text-sm"
                >
                  Locations
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-display text-sm uppercase tracking-[0.14em] text-white/50 font-medium mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 text-amber-500 mt-0.5 shrink-0" />
                <span>{company.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-amber-500 shrink-0" />
                <a href={`tel:${company.phone}`} className="hover:text-amber-400">
                  {company.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-amber-500 shrink-0" />
                <a href={`mailto:${company.email}`} className="hover:text-amber-400">
                  {company.email}
                </a>
              </li>
            </ul>
          </div>

          <FooterLatestArticles />
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-xs text-white/40 font-mono">
          <div>© {new Date().getFullYear()} Prakash Electrodes Private Limited. All rights reserved.</div>
          <div className="uppercase tracking-[0.18em]">Made in India • Kota, Rajasthan</div>
        </div>
      </div>
    </footer>
  );
}
